<mat-dialog-content>
  @if (isImage) {
    <div class="image-container">
      <img class="viewer-img" [src]="imgUrl" alt="Viewer" />
    </div>
  } @else {
    <iframe class="viewer" [src]="url" frameborder="0"></iframe>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close mat-flat-button class="m-button-outlined">
    <mat-icon>logout</mat-icon> {{ "button.close" | translate }}
  </button>
</mat-dialog-actions>
